// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"2aa40920","220":"c31c38a3","358":"71391fac","787":"aae51ac5","898":"974db181","972":"a3715395"}[chunkId] + ".chunk.js";
};